import React from 'react';

interface Props {
  classes?: string;
  score?: number;
}

export default ({ score, classes }: Props) => {
  const stars = [];

  if (score) {
    const fullStarCount = Math.floor(score);
    const hasHalfStar = score - fullStarCount > 0;
    const emptyStarCount = 5 - Math.ceil(score);
    let keyCounter = 0;

    if (fullStarCount > 0) {
      for (let i = 0; i < fullStarCount; i++) {
        stars.push(
          <i
            className={`fas fa-star ${classes}`}
            key={`star_${keyCounter}`}
          ></i>
        );
        keyCounter++;
      }
    }
    if (hasHalfStar) {
      stars.push(
        <i
          className={`fas fa-star-half-alt ${classes}`}
          key={`star_${keyCounter}`}
        ></i>
      );
      keyCounter++;
    }
    if (emptyStarCount > 0) {
      for (let i = 0; i < emptyStarCount; i++) {
        stars.push(
          <i
            className={`far fa-star ${classes}`}
            key={`star_${keyCounter}`}
          ></i>
        );
        keyCounter++;
      }
    }
  }

  return (
    <>
      {stars.map((star) => {
        return star;
      })}
    </>
  );
};
